import React from "react";
import Context from "../../Context";
import Blocker from "./Blocker";
import Scrollpane from "./Scrollpane";
import BsModal from "./BsModal";
import MaintStructTree from "../Layout/Maint/MaintStructTree";
import MaintList from "../Layout/Maint/MaintList";

export default class MaintPicker extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      structureId: "any",
      ship: {},

      pending: false,
      structureItems: null,
      structureItemsSearchDefault: [
        {
          lstr: "(",
          field: "statetypecode",
          compare: "EQL",
          value: "enabled",
        },
        {
          field: "typecode",
          compare: "EQL",
          value: "maintenance.structure",
          rstr: ")",
        },
      ],
    };
  }

  componentDidMount() {
    this.loadShip();
    this.loadStructure();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.shipId !== this.props.shipId) {
      this.loadShip();
      this.setState({ customListKey: this.context.key() });
    }
  }

  loadShip = async () => {
    this.setState({ pending: true });
    let ship = {};
    if (this.props.shipId && this.props.shipId !== "any") {
      ship = await this.context.api.q("/ship/get", {
        id: this.props.shipId,
      });
    }

    this.setState({ pending: false, ship: ship || {} });
  };

  loadStructure = async () => {
    let { structureItemsSearchDefault } = this.state;
    this.setState({ pending: true });

    let structureItems = await this.context.api.qoo(
      `/structure/list`,
      { search: structureItemsSearchDefault },
      undefined,
      undefined,
      undefined,
      "node",
      "sequence"
    );
    this.setState({ pending: false, structureItems });
  };

  onTreeClick = (item) => {
    this.setState({ structureId: item.id });
  };

  onPick = (item) => {
    this.props.onPick(item);
    this.props.onClose();
  };
  render() {
    return (
      <>
        <BsModal xl {...this.props}>
          <Blocker on={this.state.pending}>
            <div className="row">
              <div className="col-lg-5 border-right pr-3">
                {this.state.structureItems ? (
                  <Scrollpane>
                    <MaintStructTree
                      {...this.props}
                      items={this.state.structureItems}
                      onTreeClick={this.onTreeClick}
                      shipId={null}
                    />
                  </Scrollpane>
                ) : null}
              </div>
              <div className="col-lg">
                <h4 className="text-dark-50 mb-4"> {this.state.ship.name}</h4>
                <MaintList
                  shipId={this.props.shipId}
                  structureId={this.state.structureId}
                  customListKey={this.state.customListKey}
                  onPick={this.onPick}
                />
              </div>
            </div>
          </Blocker>
        </BsModal>
      </>
    );
  }
}
